<bs-digital-linear-result-model-header [title]="title" [expand]="expanded" (expandToggled)="toggleExpand($event)" />

@if (expanded) {
    @for (slip of succeededSlips; track slip; let last = $last) {
        <bs-digital-result-succeeded-pick-list [ngClass]="{ 'last-child': last }">
            @for (pick of slip.picks; track pick) {
                <bs-digital-result-succeeded-pick
                    [isLinear]="true"
                    [pick]="pick"
                    [boostedOdds]="slip.boostedOdds"
                    [oddsDisplayFormat]="oddsDisplayFormat"
                    [isSummaryVisible]="false"
                    [summary]="resultSummaryService.getSummaryViewModel(slip, betslipType)" />
            }
        </bs-digital-result-succeeded-pick-list>
    }
    @if (resultState$ | async; as resultState) {
        <bs-digital-result-keep-placed
            betType="betType"
            [isLinear]="true"
            [keepPlaced]="resultState.keepPlacedBetsInLinearSingle"
            (keepPlacedChanged)="onKeepPlacedChanged($event)" />
    }
    <bs-digital-linear-result-links [succeededSlips]="succeededSlips" [inColumn]="inColumn" />
}
